<template>
	<div class="competition">
		<page-top ref="pageTop" :subjectList="subjectList" :endTime="endTime" @back="back" @changeSubject="changeSubject"
			@submitSubject="submitSubject" @handinparperSubject="handinparperSubject"
			:showButton="type==1?'prev,next':'prev,next,submit,handinparper'" :isLookingBack="type==1?true:false">

			<template slot="content" v-if="subjectList.length">
				<acoj-render v-if="subjectList[currentTopic].problem_type == 1" ref="acojRender" @commitResult="commitResult"
					:problemInfo="subjectList[currentTopic].problem_info" hideBlock="submitBtn,evaluation,submitRecord"
					:userResult="subjectList[currentTopic].user_answer|serResultCode(subjectList[currentTopic].language)"></acoj-render>
				<csbd-render v-if="subjectList[currentTopic].problem_type == 3" ref="csbdRender"
					:problemInfo="subjectList[currentTopic].problem_info" @commitResult="commitResult"
					:userResult="subjectList[currentTopic].user_answer|serResultCode(3)"></csbd-render>
        <choice-render v-if="subjectList[currentTopic].problem_type == 10" ref="choiceRender"
                     :problemInfo="subjectList[currentTopic].problem_info" @commitResult="commitResult"
                     :userResult="subjectList[currentTopic].user_answer|serResultCode(10)"></choice-render>
			</template>

		</page-top>
		<popup-prompt ref="prompt" :title="pp.title" :showCancelBtn="pp.showCancelBtn" @confirm="confirm">
			<div class="pp-content" v-html="pp.content"></div>
		</popup-prompt>
	</div>
</template>

<script>
	import popupPrompt from "@/components/popupPrompt";
	import pageTop from "@/components/pageTop";
	import acojRender from "@/components/acojRender";
	import csbdRender from "@/components/csbdRender";
	import choiceRender from "@/components/choiceRender";
	import {
		getContestGroundInfo,
		submitProblem,
		submitContestGround,
		getContestGroundUserFinish
	} from '@/api/simulationGame'
	const eventBus = new BroadcastChannel('eventBus')
	export default {
		name: "Competition",
		components: {
			popupPrompt,
			pageTop,
			acojRender,
			csbdRender,
      choiceRender
		},
		data() {
			return {
				pp: { // 弹窗
					title: "确认交卷",
					content: "确认交卷？",
					showCancelBtn: true
				},
				contestGroundId: "", // 比赛试卷ID
				type: 0, // 0正常比赛获取题目，1查看答案
				endTime: "", // 考试结束时间
				subjectList: [], // 题目
				currentTopic: 0, // 当前题目(题目下标)
				subjectId: "", // 题目ID（题目列表进入）
				gameRunResult: null, // 编程星球运行结果
				isRunningGame: false, // 是否在运行游戏
			}
		},
		created() {
			this.contestGroundId = this.$route.query.contestGroundId;
			let type = this.$route.query.type;
			if (type == 1) {
				let subjectId = this.$route.query.subjectId;
				if (subjectId) this.subjectId = subjectId;
				this.type = type;
				this.getContestGroundUserFinish(); // 查看比赛答案
			} else {
				this.getContestGroundInfo(); // 获取比赛题目
			}
			eventBus.postMessage({
				event: 'show',
				data: {
					isShow: false
				}
			})
			eventBus.addEventListener('message', this.handleMessage); // 监听游戏提交
		},
		beforeDestroy() {
			eventBus.removeEventListener('message', this.handleMessage); // 移除游戏监听
		},
		mounted() {},
		watch: {},
		filters: {
			serResultCode(code, type) {
			  console.log('serResultCode========',type)
        type = typeof type === 'undefined' ? 1 : type
				let result = {}
				if (code) {
					if (type == 1 || type == 6) {
						result["result"] = {
							source: code,
							language: type
						}
					} else {
						result["result"] = {
							userAnswer: code,
						}
					}
				} else {
					result["result"] = "";
				}
				return result;
			}
		},
		computed: {},
		methods: {
			async getContestGroundInfo() { // 获取比赛题目
				let res = await getContestGroundInfo({
					contestGroundId: this.contestGroundId
				});
				if (res.status) {
					this.subjectList = res.data.data;
					this.endTime = res.data.end_time.date;
					// console.log("题目列表", JSON.parse(JSON.stringify(this.subjectList)));
					let subjectInfo = this.subjectList[0];
					if (subjectInfo.problem_type == 2) {
						this.setGameProblemInfo(subjectInfo);
					}
				}
			},
			async getContestGroundUserFinish() { // 查看比赛答案
				let res = await getContestGroundUserFinish({
					contestGroundId: this.contestGroundId
				});
				if (res.status) {
					let subjectList = res.data.data;
					this.subjectList = subjectList;
					// this.endTime = res.data.end_time.date;
					if (this.subjectId) { // 有题目ID则直接跳转到当前题
						for (let i = 0; i < subjectList.length; i++) {
							if (subjectList[i].id == this.subjectId) {
								this.$refs.pageTop.showSubject(i);
								this.changeSubject(i);
								break;
							}
						}
					}else {
						let subjectInfo = this.subjectList[0];
						if (subjectInfo.problem_type == 2) {
							this.setGameProblemInfo(subjectInfo);
						}
					}
				}
			},
			handleMessage(event) {
				let data = event.data;
				if (data.event === 'submitGame') {
					this.gameRunResult = data.data;
					this.commitResult(data.data);
				} else if (data.event === "runningGame") {
					this.isRunningGame = data.data == 1 ? true : false;
				}
			},
			back() { // 返回
				if (this.type == 1) {
          eventBus.postMessage({
            event: 'show',
            data: {
              isShow: false
            }
          })
					this.$router.back(); // 返回上页
				} else {
					this.pp.title = "比赛进行中";
					this.pp.content = "比赛仍在继续<br>可在比赛结束前返回赛场<br>确认暂时退出比赛？";
					this.$refs.prompt.open(0);
				}
			},
			changeSubject(num) { // 切换题目
				if(this.isRunningGame){
					this.$refs.pageTop.showSubject(this.currentTopic)
					this.$message.warning("正在运行游戏，请稍后再切换题目");
					return;
				}
				this.currentTopic = num;
				this.gameRunResult = null;
				let subjectInfo = this.subjectList[this.currentTopic];
				if (subjectInfo.problem_type == 2) {
					this.setGameProblemInfo(subjectInfo);
				} else {
					eventBus.postMessage({
						event: 'show',
						data: {
							isShow: false
						}
					})
				}
			},
			submitSubject() { // 提交题目
				let problemType = this.subjectList[this.currentTopic].problem_type;
				if (problemType == 1) {
					this.$refs.acojRender.submitCode(); // 调用oj组件中提交代码方法
				} else if (problemType == 2) {
					if (this.gameRunResult) {
						this.commitResult(this.gameRunResult);
					} else {
						this.$message.warning("请先点击运行，运行完成后才可提交");
					}
				} else if (problemType == 3) {
					this.$refs.csbdRender.submitCode();
				} else if (problemType == 10) {
          this.$refs.choiceRender.submitCode();
        }
			},
			commitResult(data) { // oj提交代码
				let subjectInfo = this.subjectList[this.currentTopic];
				let parameter = {
					id: subjectInfo.id
				}
				let problemType = subjectInfo.problem_type;
				if (problemType == 1) {
					parameter["userAnswer"] = data.codeContent;
          parameter["language"] = data.language;
					subjectInfo["user_answer"] = data.codeContent;
					subjectInfo["language"] = data.language;
				} else if (problemType == 2) {
					parameter["result"] = data.result;
					parameter["userAnswer"] = data.codeContent;
					subjectInfo["user_answer"] = data.codeContent;
				} else if (problemType == 3) {
					parameter["userAnswer"] = data.answer;
					subjectInfo["user_answer"] = data.answer;
				} else if (problemType == 10) {
          parameter["userAnswer"] = data.answer;
          subjectInfo["user_answer"] = data.answer;
        }
				submitProblem(parameter).then(res => {
					if (res.status == 1) {
						subjectInfo.is_submit = true;
						this.$message.success("提交成功");
					}
				})
			},
			handinparperSubject(type) { // 交卷
				let untitled = this.subjectList.filter(s => !s.user_answer || s.user_answer.length == 0).length;
				if (type == "active") {
					this.pp.content = `你${untitled==0?'已提交所有题目':'还有<span>'+untitled+'题</span>未提交'}<br>交卷后即退出比赛，无法再修改答案<br>确认交卷？`
				} else {
					this.pp.title = "比赛结束"
					this.pp.content = `比赛时间已结束<br>将默认交卷并退出比赛<br>你${untitled==0?'已提交所有题目':'还有<span>'+untitled+'题</span>未提交'}`
					this.pp.showCancelBtn = false
				}
				this.$refs.prompt.open(1);
			},
			confirm(type) { // 点击确定
				if (type == 1) { // 交卷
					submitContestGround({
						contestGroundId: this.contestGroundId
					}).then(res => {
						if (res.status == 1) {
							this.$message.success("试卷提交成功");
						}
					})
				}
        eventBus.postMessage({
          event: 'show',
          data: {
            isShow: false
          }
        })
				this.$router.go(-1, _ => {
					location.reload(); // 返回并刷新
				});
			},
			setGameProblemInfo(subjectInfo) {
			  console.log('subjectInfo',subjectInfo)
				eventBus.postMessage({
					event: 'problemInfo',
					data: {
						problemInfo: {
							problem: subjectInfo.problem_info,
              homeworkItemInfo: {
							  problem_type: subjectInfo.problem_type
              }
						},
						isShow: true
					}
				})
				if (subjectInfo.user_answer) {
					eventBus.postMessage({
						event: 'homeworkResult',
						data: {
							homeworkResult: {
								result: {
									code: subjectInfo.user_answer
								}
							},
							isShow: true
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.competition {
		height: 100%;
		width: 100%;
		background: url(~@/assets/img/mainBg.png) no-repeat;
		background-size: 100% 100%;
		color: #FFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
	}

	::v-deep.pp-content span {
		color: #FF4848;
		margin: 0 2px;
		font-weight: bold;
	}
</style>
